// @ts-nocheck

import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { Icon } from '../Icon'

export default class DropdownMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false
    }
    this.button = null
    this.menu = null
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClickOutside)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleClickOutside)
  }

  setButtonRef = (node) => (this.button = node)

  setMenuRef = (node) => (this.menu = node)

  handleClickOutside = (event) => {
    if (
      this.menu &&
      this.button &&
      !this.menu.contains(event.target) &&
      !this.button.contains(event.target)
    ) {
      this.setState({ menuOpen: false })
    }
  }

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen
    }))
  }

  renderMenu = () => {
    const { items, menuStyle } = this.props

    return (
      <div
        className="lmc-dropdown-menu"
        ref={this.setMenuRef}
        style={menuStyle}
      >
        {items.map((item, i) => (
          <div
            className="lmc-dropdown-menu-option"
            key={i}
            onClick={() => {
              item.onClick()
              this.toggleMenu()
            }}
            style={styles.menuItem}
          >
            {item.label}
          </div>
        ))}
      </div>
    )
  }

  render() {
    const { component, buttonStyle } = this.props

    return (
      <div style={styles.wrapper}>
        {component ? (
          <div ref={this.setButtonRef}>
            {React.cloneElement(component, {
              onClick: this.toggleMenu,
              style: buttonStyle
            })}
          </div>
        ) : (
          <div
            className="dropdown-menu-button"
            onClick={this.toggleMenu}
            ref={this.setButtonRef}
            style={{
              ...styles.button,
              ...buttonStyle
            }}
          >
            <Icon name="three-dots" fill="black" size={24} />
          </div>
        )}
        {this.state.menuOpen && this.renderMenu()}
      </div>
    )
  }
}

const styles = {
  button: {
    cursor: 'pointer',
    height: '100%'
  },
  menuItem: {
    color: colors.black,
    fontSize: 13
  },
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    height: '100%'
  }
}

DropdownMenu.propTypes = {
  buttonStyle: PropTypes.object,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired
    })
  ).isRequired,
  menuStyle: PropTypes.object
}
